import React, { useEffect, useState } from 'react'
import { HorizontalLayout, FlexWrap } from '../Components'
import './TranscriptCard.css'
import cx from '../Utils/cx'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import {
    deleteTranscriptById,
    updateTranscriptById,
    updateMediaById,
} from '../Studio/api'
import { defaultKeys } from '../Studio/constants'
import toast from 'react-hot-toast'
import axios from 'axios'
import { Button, Form } from 'react-bootstrap'
import DownloadButton from '../Components/DownloadButton'

const getTranscriptDownload = (transcript) => {
    const preferredUrl = transcript?.draftResourceUrl
        || transcript?.tempResourceUrl
        || transcript?.azureResourceUrl
        || transcript?.path

    const fileName = preferredUrl?.split('/').filter(Boolean).pop() || ''

    return { fileName }
}

const TranscriptCard = ({ data, refresh, type, media }) => {
    const mediaType = 'transcriptCard'
    const history = useHistory()
    const [isDeleted, setIsDeleted] = useState(false)
    const [inputName, setInputName] = useState(data?.name || '')
    const { fileName: derivedFileName } = getTranscriptDownload(data)

    const defaultKey = type ? defaultKeys[type] : null
    const isDefault = !!media && !!defaultKey && media[defaultKey] === data._id

    useEffect(() => {
        setInputName(data?.name || '')
    }, [data])

    const handleUpdateTranscript = async () => {
        const id = data?._id
        if (!id) return
        try {
            await toast.promise(updateTranscriptById(id, inputName), {
                loading: `Update transcript: ${id} name to ${inputName}!`,
                success: `Successfully set transcript name to ${inputName}`,
                error: (err) => `Error: ${err}`,
            })
            if (refresh) refresh()
        } catch (err) {
            console.error(err)
        }
    }

    const handleEdit = () => {
        const { mediaId, _id: transcriptId } = data
        history.push(`/recording/${mediaId}/transcript/${transcriptId}`)
    }

    const handleSetDefault = async () => {
        const mediaId = media?._id
        const transcriptId = data?._id
        if (!mediaId || !defaultKey || !transcriptId) {
            console.error('Missing mediaId, type, or transcriptId for setDefault')
            return
        }
        const updates = {}
        updates[defaultKey] = transcriptId
        try {
            await toast.promise(updateMediaById(mediaId, updates), {
                loading: `Setting transcript: ${transcriptId} as default!`,
                success: `Successfully set transcript: ${transcriptId} as default!`,
                error: (err) => `Error: ${err}`,
            })
            if (refresh) refresh()
        } catch (e) {
            console.error(e)
        }
    }

    const handleDelete = async () => {
        try {
            const r = window.confirm('Are you sure you want to delete?')
            if (!r) {
                return false
            }
            const id = data._id
            toast
                .promise(
                    deleteTranscriptById(id),
                    {
                        loading: `Delete Transcript: ${id}`,
                        success: `Successfully deleted transcript: ${id}!`,
                        error: (err) => `Error: ${err}`,
                    },
                    {
                        success: {
                            icon: '🗑',
                        },
                    }
                )
                .then((result) => {
                    console.log(result)
                    setIsDeleted(true)
                })
        } catch (err) {
            console.error(err)
        }
    }

    // DEFAULT DRAFT
    // UPLOAD TRANSCRIPT FROM DEFAULT TO PUBLISH 
    const handlePublishTranscript = async (id) => {

        const r = window.confirm('Are you sure you want to publish this transcript?')
        if (!r) {
            return false
        }
        try {

            const id = data._id
            const response = await axios.post(
                `${process.env.REACT_APP_STUDIO_URL}/transcript/publish`,
                { id: id }
            )
            if (!response.data.success) throw new Error(response.data.error)
            toast.success('Transcript published successfully');
            if (refresh) refresh();
        } catch (ex) {
            toast.error(ex.message)
        }

    }

    if (isDeleted) {
        return null
    }

    return (
        <div className={cx('cardContainer', mediaType)}>
            <div className="d-flex justify-content-between">
                <Form className="d-flex align-items-center">
                    <Form.Group className="d-flex align-items-center mr-3">
                        <Form.Label className="mb-0 mr-2">Name:</Form.Label>
                        <Form.Control
                            type="text"
                            value={inputName}
                            onChange={(e) => setInputName(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Button
                            variant="outline-dark"
                            onClick={handleUpdateTranscript}
                        >
                            Save
                        </Button>
                    </Form.Group>
                </Form>
            </div>
            <FlexWrap style={{ justifyContent: 'space-between' }}>
                <p>Transcript ID: {data._id}</p>
                <p>Created At: {moment(data.createdAt).fromNow()}</p>
                <p>Last Updated At: {moment(data.updatedAt).fromNow()}</p>
            </FlexWrap>
            <p>{data.isAutoGenerated ? 'Auto Generated' : 'Uploaded'}</p>
            <HorizontalLayout>
                <button
                    onClick={handleEdit}
                    className="btn btn-outline-success mr-2"
                >
                    Edit
                </button>
                {data.draftResourceUrl !== '' && <Button
                    type="button"
                    variant="outline-warning"
                    className="mr-2"
                    onClick={handlePublishTranscript}
                > Publish </Button>
                }
                <Button
                    type="button"
                    variant={isDefault ? 'outline-secondary' : 'outline-success'}
                    className="mr-2"
                    disabled={isDefault}
                    onClick={handleSetDefault}
                >
                    {isDefault ? 'Default' : 'Set Default'}
                </Button>
                <DownloadButton
                    fileName={derivedFileName}
                    transcriptId={data._id}
                    className="btn btn-info text-light mr-2"
                />

                <button onClick={handleDelete} className="btn btn-danger">
                    Delete
                </button>
            </HorizontalLayout>
        </div>
    )
}

export default TranscriptCard